import { AxiosAdapter } from '../../adapters/axios';

class HttpClient {
	constructor(Client) {
		this.client = new Client();
	}

	/**
   * Gets a token from the local storage
   *
   * @returns {string}
   */
	get token() {
		return localStorage.getItem('token');
	}

	/**
   * Sets new token to the client and local storage, if null is passed removes the token
   *
   * @param token
   */
	set token(token) {
		if (token !== null) {
			localStorage.setItem('token', token);
			this.client.setToken(token);
		} else {
			localStorage.removeItem('token');
			this.client.setToken(token);
		}
	}

	/**
   * Request factory, handles any HTTP request (GET, POST, PUT, PATCH, DELETE)
   *
   * @param {string} method
   * @param {string} url
   * @param rest
   * @returns {function}
   */
	async request(method, url, ...rest) {
		return this.client[method.toLowerCase()](url, ...rest);
	}
}

export const http = new HttpClient(AxiosAdapter);
